import { getShowEnsGoodsBanner } from "../../../../common/goods/goodsUtils";
import type { UpdateSubmitInformation } from "../../../../common/update-information/utils/getUpdateSubmitInformation";
import type { MinimalBooking } from "../../../../common/utils/minimalBooking";

export const ENS_CARGO_HINT_MESSAGE_CODE = "IEXT-010";

export const resolveEnsCargoHintInformation = (
  updateSubmitInformation: UpdateSubmitInformation,
  minimalBooking: MinimalBooking,
  ensConfirmed: boolean,
) => {
  return (
    !updateSubmitInformation.messages.some(
      (m) => m.code === ENS_CARGO_HINT_MESSAGE_CODE,
    ) && getShowEnsGoodsBanner(minimalBooking, { ensConfirmed })
  );
};
